"use client";

import { useState } from "react";
import { ArrowUpRight, BookOpen, ChevronDown, Quote } from "lucide-react";
import { assetUrl, homeUrl } from "@/lib/assets";
interface DoctrineItem {
  id: number;
  slug: string;
  number: string;
  title: string;
  summary: string;
  scriptures: string;
}
const doctrines: DoctrineItem[] = [{
  id: 1,
  slug: "doctrina-1",
  number: "01",
  title: "La Inspiración de las Escrituras",
  summary: "Las Escrituras, tanto el Antiguo como el Nuevo Testamento, son verbalmente inspiradas por Dios y son la revelación de Dios para el hombre, la regla infalible y autoritativa de fe y conducta.",
  scriptures: "2 Timoteo 3:15-17; 1 Tesalonicenses 2:13; 2 Pedro 1:21"
}, {
  id: 2,
  slug: "doctrina-2",
  number: "02",
  title: "El Único Dios Verdadero",
  summary: "El único Dios verdadero se ha revelado a sí mismo como el eternamente autoexistente «YO SOY», el Creador del cielo y de la tierra y el Redentor de la humanidad. Se ha revelado además encarnando los principios de relación y asociación como Padre, Hijo y Espíritu Santo.",
  scriptures: "Deuteronomio 6:4; Isaías 43:10,11; Mateo 28:19; Lucas 3:22"
}, {
  id: 3,
  slug: "doctrina-3",
  number: "03",
  title: "La Deidad del Señor Jesucristo",
  summary: "El Señor Jesucristo es el eterno Hijo de Dios. Las Escrituras declaran Su nacimiento virginal, Su vida sin pecado, Sus milagros, Su obra expiatoria en la cruz, Su resurrección corporal de entre los muertos y Su exaltación a la diestra de Dios.",
  scriptures: "Mateo 1:23; Hebreos 7:26; 1 Corintios 15:3,4; Filipenses 2:9-11"
}, {
  id: 4,
  slug: "doctrina-4",
  number: "04",
  title: "La Caída del Hombre",
  summary: "El hombre fue creado bueno y recto; porque Dios dijo: «Hagamos al hombre a nuestra imagen, conforme a nuestra semejanza». Sin embargo, el hombre, por transgresión voluntaria, cayó y con ello incurrió no sólo en la muerte física sino también en la espiritual, que es la separación de Dios.",
  scriptures: "Génesis 1:26,27; 2:17; 3:6; Romanos 5:12-19"
}, {
  id: 5,
  slug: "doctrina-5",
  number: "05",
  title: "La Salvación del Hombre",
  summary: "La única esperanza de redención para el ser humano es a través de la sangre derramada de Jesucristo, el Hijo de Dios. La salvación se recibe a través del arrepentimiento hacia Dios y la fe en el Señor Jesucristo.",
  scriptures: "Lucas 24:47; Juan 3:3; Romanos 10:13-15; Efesios 2:8; Tito 2:11"
}, {
  id: 6,
  slug: "doctrina-6",
  number: "06",
  title: "Las Ordenanzas de la Iglesia",
  summary: "El bautismo en agua por inmersión es mandado en las Escrituras a todos los que se han arrepentido y han creído de corazón en Cristo. La Santa Cena del Señor, consistente en los elementos del pan y el fruto de la vid, es el símbolo que expresa nuestra participación de la naturaleza divina de nuestro Señor Jesucristo.",
  scriptures: "Mateo 28:19; Marcos 16:16; Romanos 6:4; 1 Corintios 11:26; 2 Pedro 1:4"
}, {
  id: 7,
  slug: "doctrina-7",
  number: "07",
  title: "El Bautismo en el Espíritu Santo",
  summary: "Todos los creyentes tienen el derecho de esperar y deben buscar fervientemente la promesa del Padre, el bautismo en el Espíritu Santo y fuego, según el mandato de nuestro Señor Jesucristo. Esta era la experiencia normal y continua de todos en la iglesia cristiana primitiva.",
  scriptures: "Lucas 24:49; Hechos 1:4,8; 1 Corintios 12:1-31; Hechos 10:44-46"
}, {
  id: 8,
  slug: "doctrina-8",
  number: "08",
  title: "La Evidencia Física Inicial",
  summary: "El bautismo de los creyentes en el Espíritu Santo se evidencia físicamente por la señal inicial de hablar en otras lenguas según el Espíritu de Dios les dé que hablen. El hablar en lenguas en esta instancia es el mismo en esencia que el don de lenguas, pero diferente en propósito y uso.",
  scriptures: "Hechos 2:4; 1 Corintios 12:4-10; 1 Corintios 12:28"
}, {
  id: 9,
  slug: "doctrina-9",
  number: "09",
  title: "La Santificación",
  summary: "La santificación es un acto de separación de todo lo que es malo, y de dedicación a Dios. Las Escrituras enseñan una vida de «santidad sin la cual nadie verá al Señor». Por el poder del Espíritu Santo somos capacitados para obedecer el mandato divino.",
  scriptures: "1 Tesalonicenses 5:23; Romanos 12:1,2; Hebreos 12:14; 1 Pedro 1:15,16"
}, {
  id: 10,
  slug: "doctrina-10",
  number: "10",
  title: "La Iglesia y su Misión",
  summary: "La Iglesia es el cuerpo de Cristo, la morada de Dios por el Espíritu, con nombramientos divinos para el cumplimiento de su gran comisión. Cada creyente, nacido del Espíritu, es una parte integral de la asamblea general y de la iglesia de los primogénitos inscritos en los cielos.",
  scriptures: "Efesios 1:22,23; 2:22; Hebreos 12:23; Marcos 16:15-20"
}, {
  id: 11,
  slug: "doctrina-11",
  number: "11",
  title: "El Ministerio",
  summary: "Un ministerio provisto divinamente y llamado según las Escrituras ha sido ordenado por nuestro Señor con un cuádruple propósito: la evangelización del mundo, la adoración a Dios, la edificación del cuerpo de Cristo y la manifestación de Su compasión.",
  scriptures: "Marcos 16:15-20; Juan 4:23,24; Efesios 4:11-16; Santiago 1:27"
}, {
  id: 12,
  slug: "doctrina-12",
  number: "12",
  title: "Sanidad Divina",
  summary: "La sanidad divina es una parte integral del evangelio. La liberación de la enfermedad ha sido provista en la expiación y es el privilegio de todos los creyentes.",
  scriptures: "Isaías 53:4,5; Mateo 8:16,17; Santiago 5:14-16"
}, {
  id: 13,
  slug: "doctrina-13",
  number: "13",
  title: "La Esperanza Bienaventurada",
  summary: "La resurrección de los que han muerto en Cristo y su arrebatamiento juntamente con aquellos que estén vivos en la venida del Señor es la esperanza inminente y bienaventurada de la Iglesia.",
  scriptures: "1 Tesalonicenses 4:16,17; Romanos 8:23; Tito 2:13; 1 Corintios 15:51,52"
}, {
  id: 14,
  slug: "doctrina-14",
  number: "14",
  title: "El Reino Milenario de Cristo",
  summary: "La segunda venida de Cristo incluye el rapto de los santos, seguido por el regreso visible de Cristo con sus santos para reinar sobre la tierra por mil años. Este reino milenario traerá la salvación de Israel y una paz universal.",
  scriptures: "Zacarías 14:5; Mateo 24:27,30; Apocalipsis 1:7; 19:11-14; 20:1-6"
}, {
  id: 15,
  slug: "doctrina-15",
  number: "15",
  title: "El Juicio Final",
  summary: "Habrá un juicio final en el cual los impíos muertos serán resucitados y juzgados según sus obras. Cualquiera cuyo nombre no se halle inscrito en el Libro de la Vida será lanzado al lago de fuego para castigo eterno, junto con el diablo y sus ángeles.",
  scriptures: "Mateo 25:46; Marcos 9:43-48; Apocalipsis 19:20; 20:11-15; 21:8"
}, {
  id: 16,
  slug: "doctrina-16",
  number: "16",
  title: "Cielos Nuevos y Tierra Nueva",
  summary: "«Pero nosotros esperamos, según sus promesas, cielos nuevos y tierra nueva, en los cuales mora la justicia». Una morada eterna y perfecta preparada por Dios para Su pueblo.",
  scriptures: "2 Pedro 3:13; Apocalipsis 21; Apocalipsis 22"
}];
export default function DoctrinalCatalog() {
  const [openItems, setOpenItems] = useState<number[]>([1]);
  const toggleItem = (id: number) => {
    setOpenItems(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
  };
  return (
    <section id="doctrinalcatalog" data-nav="light" className="acad-beliefs-catalog">
      <div className="acad-beliefs-shell">
        <header className="acad-beliefs-catalog-head">
          <div>
            <span className="acad-beliefs-eyebrow">Nuestra declaración</span>
            <h2>Lo que creemos<br />da forma a cómo vivimos.</h2>
          </div>
          <p>
            La Biblia es nuestra regla todo-suficiente de fe y conducta. Estas
            verdades sirven de base para nuestra comunión y expresan lo esencial
            para un ministerio del evangelio completo.
          </p>
        </header>

        <div className="acad-beliefs-note">
          <Quote aria-hidden="true" />
          <p>
            Esta declaración no pretende contener toda la verdad bíblica, sino
            expresar con claridad las doctrinas fundamentales que compartimos.
          </p>
          <span>1 Corintios 1:10 · Hechos 2:42</span>
        </div>

        <div className="acad-beliefs-list">
          {doctrines.map((doctrine) => {
            const isOpen = openItems.includes(doctrine.id);
            const panelId = `${doctrine.slug}-contenido`;

            return (
              <article className={isOpen ? "is-open" : ""} id={doctrine.slug} key={doctrine.id}>
                <button
                  type="button"
                  onClick={() => toggleItem(doctrine.id)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                >
                  <span className="acad-beliefs-doctrine-number">{doctrine.number}</span>
                  <span className="acad-beliefs-doctrine-title">{doctrine.title}</span>
                  <i><ChevronDown aria-hidden="true" /></i>
                </button>

                {isOpen && (
                  <div className="acad-beliefs-doctrine-panel" id={panelId}>
                    <p>{doctrine.summary}</p>
                    <div>
                      <BookOpen aria-hidden="true" />
                      <span>
                        <strong>Referencias bíblicas</strong>
                        {doctrine.scriptures}
                      </span>
                    </div>
                  </div>
                )}
              </article>
            );
          })}
        </div>

        <section className="acad-beliefs-closing">
          <div className="acad-beliefs-closing-media">
            <img
              src={assetUrl("mission_worship_speaker.png")}
              alt="Iglesia reunida alrededor de la Palabra y la adoración"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="acad-beliefs-closing-copy">
            <span className="acad-beliefs-eyebrow acad-beliefs-eyebrow--light">Fe que se vive</span>
            <h2>La doctrina no termina en una declaración.</h2>
            <p>
              Nos mueve a adorar, compartir el evangelio, formar discípulos y
              mostrar la compasión de Jesús en cada comunidad.
            </p>
            <a href={homeUrl("contacto/?tema=general#contacto-formulario")}>
              Conversar con nosotros <ArrowUpRight aria-hidden="true" />
            </a>
          </div>
        </section>
      </div>
    </section>
  );
}
